// Friendly empty / no-data placeholder.

function EmptyState({ icon: Icon, title = 'Nothing here yet', message, action }) {
  return (
    <div className="card text-center py-12">
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-2xl bg-ink-100 text-ink-400 flex items-center justify-center mb-3">
          <Icon className="w-6 h-6" />
        </div>
      )}
      <p className="font-semibold text-ink-700">{title}</p>
      {message && <p className="text-sm text-ink-500 mt-1 max-w-md mx-auto">{message}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

export default EmptyState;
